import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { List, ListItem } from '@mui/material';
import clsx from 'clsx';

import { ISideMenuProps as IProps } from './types';

import styles from './SideMenu.module.scss';

export const SideMenu: FC<IProps> = ({ menuItems }) => {
  const navLinkStyles = ({ isActive }: { isActive: boolean }) => clsx(styles.navLink, isActive && styles.active);

  return (
    <List className={styles.menuList}>
      {menuItems.map(({ title, path }) => (
        <ListItem key={title + path} className={styles.menuListItem}>
          <NavLink className={navLinkStyles} to={path}>
            {title}
          </NavLink>
        </ListItem>
      ))}
    </List>
  );
};
